import React, { useEffect } from "react";
import { UseTutorialApi, UseTutorialOptions, useTutorial } from "./useTutorial";

export interface TutorialTourProps extends UseTutorialOptions {
  autoStart?: boolean;
  children?: (api: UseTutorialApi) => React.ReactNode;
}

// Top-level wiring: renders nothing DOM-visible by default (driver.js manages
// its own overlay) but exposes the useTutorial API via render prop for a
// caller-provided trigger surface.
//
// Usage:
//   <TutorialTour autoStart onEvent={handleGA4} translate={t}>
//     {(api) => api.status === "idle" && <button onClick={api.start}>Start</button>}
//   </TutorialTour>
export function TutorialTour(props: TutorialTourProps) {
  const { autoStart = false, children, ...hookOptions } = props;
  const api = useTutorial(hookOptions);

  useEffect(() => {
    if (
      autoStart &&
      api.status === "idle" &&
      !api.isMobileAndDisabled
    ) {
      api.start();
    }
    // start is stable via useCallback; guard prevents restart on state churn.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoStart, api.status, api.isMobileAndDisabled]);

  return <>{children ? children(api) : null}</>;
}
